import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        personalInfo: {
            allFields: string;
        },
        error: {
            either: string;
            tryAgain: string;
            contact: string;
        },
    },
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    emailAddress: 'Work Email Address',
    emailExplanation: ' ',
    verifyMyMembershipStatus: 'VERIFY AND CONTINUE',
    infoShared1: 'Information entered into this web form will be used for verification purposes. The information will be shared with Sena Cases.',
    infoShared2: ' ',
    error: 'OOPS, SOMETHING WENT WRONG.',
    poweredBy: 'Verification services powered by SheerID.',
        errorId: {
            notApproved: 'Sorry, we could not determine eligibility based on the company name and email address provided.',
        },
        step: {
        personalInfo: {
            title: 'Confirm your eligibility by simply completing the form below for this special employee offer.',
            subtitle: 'STEP 1: VERIFY YOUR DETAILS',
            allFields: 'All fields are required.'
        },
        success: {
            title: 'STEP 2: SUCCESS',
            subtitle: 'We have emailed you a code. Look for the email from verify@sheerid.com.',
            verificationOnly: 'SheerID handles verification only. Now that you\'ve been approved, please direct all questions about the promotion terms and/or code use to Sena customer service.',
        },
        error: {
            either: 'Either ',
            tryAgain: 'try again ',
            contact: 'or contact your employee discount program administrator for further assistance.',
        },

    },
};
